/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/ru';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Обращение к редактору HTML Pretty"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Контроллер доступности"
  },
  "action_to_take_b626a99a": {
    "message": "Что необходимо сделать:"
  },
  "add_8523c19b": {
    "message": "Добавить"
  },
  "add_a_caption_2a915239": {
    "message": "Добавить надпись"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Добавить альтернативный текст для изображения"
  },
  "add_another_f4e50d57": {
    "message": "Добавить другой"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Добавить копию/подзаголовки"
  },
  "add_image_60b2de07": {
    "message": "Добавить изображение"
  },
  "add_one_9e34a6f8": {
    "message": "Добавьте одну!"
  },
  "additional_considerations_f3801683": {
    "message": "Дополнительные факторы"
  },
  "address_applied_64269b0b": {
    "message": "Адрес применен"
  },
  "address_removed_fcb496e0": {
    "message": "Адрес удален"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Соседние ссылки с одним и тем же URL-адресом должны быть объединены в одну ссылку."
  },
  "aleph_f4ffd155": {
    "message": "Алеф"
  },
  "align_11050992": {
    "message": "Согласовать"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Согласование и списки"
  },
  "all_4321c3a1": {
    "message": "Все"
  },
  "all_apps_a50dea49": {
    "message": "Все приложения"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Разрешить скачивание мультимедиа"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Разрешить скачивание стенограммы"
  },
  "alpha_15d59033": {
    "message": "Альфа"
  },
  "alphabetical_55b5b4e0": {
    "message": "Буквенный"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Альтернативный атрибутивный текст не должен содержать более 120 символов."
  },
  "alt_text_611fb322": {
    "message": "Альтернативный текст"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Амальг (сопутствующий продукт)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Произошла ошибка при чтении файла"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Произошла ошибка, что привело к созданию сетевого запроса"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Произошла ошибка при отправке вашего мультимедиа."
  },
  "and_7fcc2911": {
    "message": "И"
  },
  "angle_c5b4ec50": {
    "message": "Угол"
  },
  "announcement_fb4cb645": {
    "message": "Объявление"
  },
  "announcement_list_da155734": {
    "message": "Список объявлений"
  },
  "announcements_a4b8ed4a": {
    "message": "Объявления"
  },
  "apply_781a2546": {
    "message": "Применить"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Применить изменения ко всем экземплярам этого значка, созданного с помощью средства создания значков в курсе"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Приближается к ограничению"
  },
  "approximately_e7965800": {
    "message": "Примерно"
  },
  "apps_54d24a47": {
    "message": "Приложения"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Вы действительно хотите отменить это действие? Внесенные вами изменения не могут быть сохранены."
  },
  "arrows_464a3e54": {
    "message": "Стрелки"
  },
  "art_icon_8e1daad": {
    "message": "Значок искусства"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Соотношение сторон будет сохранено"
  },
  "assignment_976578a8": {
    "message": "Задание"
  },
  "assignments_1e02582c": {
    "message": "Задания"
  },
  "asterisk_82255584": {
    "message": "Звездочка"
  },
  "attributes_963ba262": {
    "message": "Атрибуты"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Аудио- и видеозапись не поддерживается; воспользуйтесь другим браузером."
  },
  "audio_options_feb58e2c": {
    "message": "Параметры звука"
  },
  "audio_options_tray_33a90711": {
    "message": "Панель настройки параметров звука"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Аудиоплеер для { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Существует сохраненное в автоматическом режиме содержимое. Вы хотите загрузить сохраненное в автоматическом режиме содержимое?"
  },
  "available_folders_694d0436": {
    "message": "Доступные папки"
  },
  "background_1bc88842": {
    "message": "Исходные данные"
  },
  "backslash_b2d5442d": {
    "message": "Обратная косая черта"
  },
  "bar_ec63ed6": {
    "message": "Полоса"
  },
  "basic_554cdc0a": {
    "message": "Основной"
  },
  "because_501841b": {
    "message": "Потому что"
  },
  "below_81d4dceb": {
    "message": "Ниже"
  },
  "beta_cb5f307e": {
    "message": "Бета"
  },
  "big_circle_16b2e604": {
    "message": "Большой круг"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Биноминальный коэффициент"
  },
  "black_4cb01371": {
    "message": "Черный"
  },
  "blue_daf8fea9": {
    "message": "Синий"
  },
  "bold_applied_42d547b7": {
    "message": "Жирный применен"
  },
  "bold_removed_da474a5c": {
    "message": "Жирный удален"
  },
  "border_5b08b06d": {
    "message": "Граница"
  },
  "bottom_15a2a9be": {
    "message": "Низ"
  },
  "bottom_third_5f5fec1d": {
    "message": "Нижняя треть"
  },
  "bowtie_5f9629e4": {
    "message": "Галстук-бабочка"
  },
  "brick_f2656265": {
    "message": "Блок"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 г. Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Отменить"
  },
  "cap_product_3a5265a6": {
    "message": "Произведение Уитни"
  },
  "caption_manager_aae0906f": {
    "message": "Менеджер заголовков"
  },
  "center_align_e68d9997": {
    "message": "Совмещение по центру"
  },
  "centered_dot_64d5e378": {
    "message": "Интерпункт"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Горизонтальные интерпункты"
  },
  "change_alt_text_92654906": {
    "message": "Изменить альтернативный текст"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Изменить тег заголовка параграфа"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Изменить уровень только этого заголовка"
  },
  "change_text_color_1aecb912": {
    "message": "Изменить цвет текста"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Изменения будут применены после сохранения этой страницы"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Внесенные вами изменения не могут быть сохранены."
  },
  "characters_9d897d1c": {
    "message": "Символы"
  },
  "characters_no_spaces_485e5367": {
    "message": "Символы (без пробелов)"
  },
  "check_accessibility_3c78211c": {
    "message": "Проверить доступность"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Проверка на отсутствие проблем, связанных с доступностью"
  },
  "chi_54a32644": {
    "message": "Ци"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Выберите файл подписи к изображению"
  },
  "choose_usage_rights_33683854": {
    "message": "Выбрать права на использование..."
  },
  "circle_484abe63": {
    "message": "Круг"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "заключить неупорядоченный список в круг"
  },
  "clear_2084585f": {
    "message": "Очистить"
  },
  "clear_image_3213fe62": {
    "message": "Удалить изображение"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Щелкнуть или щелкнуть с нажатием на клавишу shift, чтобы обратиться к редактору html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Щелкните, чтобы внедрить { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Нажмите, чтобы скрыть предпросмотр"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Нажмите, чтобы вставить ссылку в редактор."
  },
  "click_to_show_preview_faa27051": {
    "message": "Нажмите, чтобы показать предпросмотр"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Закройте меню или диалог. Также возвращает вас в область редактора"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Закрыть контроллер доступности"
  },
  "close_d634289d": {
    "message": "Закрыть"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Закрыть модальное окно сочетаний клавиш"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Размер закрытого файла субтитров должен быть меньше { maxKb } Кб"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Закрытые надписи/субтитры"
  },
  "clubs_suit_c1ffedff": {
    "message": "Трефы (масть)"
  },
  "collab_575ac7bc": {
    "message": "Взаимодействие"
  },
  "collaborations_5c56c15f": {
    "message": "Совместная работа"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Свернуть, чтобы скрыть { types }"
  },
  "color_a363e1b0": {
    "message": "Цвет"
  },
  "color_contrast_4c418add": {
    "message": "Цветовой контраст"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Коэффициент цветового контраста"
  },
  "color_picker_6b359edf": {
    "message": "Селектор цвета"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Селектор цвета (выбрано { colorName })"
  },
  "color_popup_af39810f": {
    "message": "Цветное всплывающее окно"
  },
  "column_e1ae5c64": {
    "message": "Колонка"
  },
  "column_group_1c062368": {
    "message": "Группа колонок"
  },
  "complex_numbers_a543d004": {
    "message": "Комплексные числа"
  },
  "computer_1d7dfa6f": {
    "message": "Компьютер"
  },
  "congruent_5a244acd": {
    "message": "Согласующийся"
  },
  "contains_311f37b7": {
    "message": "Содержит"
  },
  "content_1440204b": {
    "message": "Содержимое"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Содержимое в редакторе будет изменено. Нажмите \"Отмена\", чтобы сохранить исходное содержимое."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Выгрузка контента еще не завершена, в случае продолжения вами данного действия он не будет внедрен правильно."
  },
  "content_subtype_5ce35e88": {
    "message": "Подтип контента"
  },
  "content_type_2cf90d95": {
    "message": "Тип содержимого"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Перейти к содержимому YouTube"
  },
  "coproduct_e7838082": {
    "message": "Сопутствующий продукт"
  },
  "copyright_holder_66ee111": {
    "message": "Правообладатель:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Не удалось вставить содержимое: Элементы \"{ itemType }\" в настоящее время не поддерживаются в Canvas."
  },
  "count_40eced3b": {
    "message": "Счет"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 слов}\n    one {1 слово}\n  other {# слов(-а)}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# элемент загружен}\n  other {# элементов (элемента) загружено}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Документы курса"
  },
  "course_files_62deb8f8": {
    "message": "Файлы курса"
  },
  "course_files_a31f97fc": {
    "message": "Файлы курса"
  },
  "course_images_f8511d04": {
    "message": "Изображения курса"
  },
  "course_link_b369426": {
    "message": "Ссылка на курс"
  },
  "course_links_b56959b9": {
    "message": "Ссылки курса"
  },
  "course_media_ec759ad": {
    "message": "Мультимедиа курса"
  },
  "course_navigation_dd035109": {
    "message": "Навигация курса"
  },
  "create_icon_110d6463": {
    "message": "Создать значок"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Создать значок, созданный с помощью Средства создания значков"
  },
  "creative_commons_license_725584ae": {
    "message": "Лицензионное соглашение Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Обрезать изображение"
  },
  "crop_image_807ebb08": {
    "message": "Обрезать изображение"
  },
  "cup_product_14174434": {
    "message": "U-произведение"
  },
  "current_image_f16c249c": {
    "message": "Текущее изображение"
  },
  "current_link_945a47ee": {
    "message": "Актуальная ссылка"
  },
  "current_volume_level_c55ab825": {
    "message": "Уровень текущего объема"
  },
  "custom_6979cd81": {
    "message": "Пользовательская"
  },
  "cyan_c1d5f68a": {
    "message": "Голубой"
  },
  "dagger_57e0f4e5": {
    "message": "Знак сноски"
  },
  "date_added_ed5ad465": {
    "message": "Дата добавления"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Декоративный значок"
  },
  "decorative_image_fde98579": {
    "message": "Декоративное изображение"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Декоративный { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Уменьшить отступ"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Уменьшить область с богатым содержимым"
  },
  "deep_purple_bb3e2907": {
    "message": "Темно-фиолетовый"
  },
  "default_9db103d": {
    "message": "По умолчанию"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "маркированный неупорядоченный список по умолчанию"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "нумерованный упорядоченный список по умолчанию"
  },
  "definite_integral_fe7ffed1": {
    "message": "Определенный интеграл"
  },
  "degree_symbol_4a823d5f": {
    "message": "Символ градуса"
  },
  "delimiters_4db4840d": {
    "message": "Разделители"
  },
  "delta_53765780": {
    "message": "Дельта"
  },
  "describe_the_icon_f6a18823": {
    "message": "(опишите значок)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Опишите { TYPE })"
  },
  "description_436c48d7": {
    "message": "Описание"
  },
  "details_98a31b68": {
    "message": "Подробные сведения"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Диагональные точки"
  },
  "diamond_b8dfe7ae": {
    "message": "Ромб"
  },
  "diamonds_suit_526abaaf": {
    "message": "Бубны (масть)"
  },
  "digamma_258ade94": {
    "message": "Дигамма"
  },
  "dimension_type_f5fa9170": {
    "message": "Тип измерения"
  },
  "directionality_26ae9e08": {
    "message": "Направленность"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Непосредственно редактирование LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Отключить предварительный просмотр"
  },
  "discussion_6719c51d": {
    "message": "Обсуждение"
  },
  "discussions_a5f96392": {
    "message": "Обсуждения"
  },
  "discussions_index_6c36ced": {
    "message": "Индекс обсуждений"
  },
  "disjoint_union_e74351a8": {
    "message": "Несвязное объединение"
  },
  "display_options_315aba85": {
    "message": "Опции отображения"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Показать текстовую ссылку (открывается в новой вкладке)"
  },
  "div_applied_49ad83fc": {
    "message": "Div применен"
  },
  "div_removed_d13f8e17": {
    "message": "Div удален"
  },
  "division_sign_72190870": {
    "message": "Знак деления"
  },
  "document_678cd7bf": {
    "message": "Документ"
  },
  "documents_81393201": {
    "message": "Документы"
  },
  "done_54e3d4b6": {
    "message": "Готово"
  },
  "double_dagger_faf78681": {
    "message": "Двойной крестик"
  },
  "down_5831a426": {
    "message": "Вниз"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Направленная вниз и влево стрелка"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Направленная вниз и вправо стрелка"
  },
  "download_filename_2baae924": {
    "message": "Скачать { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Направленная вниз стрелка"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Треугольник вершиной вниз"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Перетащите файл сюда"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Перетащите или щелкните, чтобы просмотреть свой компьютер"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Перетаскивание. Используйте стрелки вверх и вниз для изменения размера"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Срок: Несколько дат"
  },
  "due_when_7eed10c6": {
    "message": "Срок: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Редактировать альтернативный текст для этого экземпляра значка"
  },
  "edit_c5fbea07": {
    "message": "Редактировать"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Редактировать ссылку на курс"
  },
  "edit_equation_f5279959": {
    "message": "Редактировать уравнение"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Редактировать существующий значок, созданный с помощью средства создания значков"
  },
  "edit_icon_2c6b0e91": {
    "message": "Редактировать значок"
  },
  "edit_link_7f53bebb": {
    "message": "Редактировать ссылку"
  },
  "editor_status_bar_653f44ee": {
    "message": "Панель состояния редактора"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Элемент, начинающийся с { start }"
  },
  "embed_828fac4a": {
    "message": "Вставить"
  },
  "embed_code_314f1bd5": {
    "message": "Внедрить код"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Интегрированный контент из внешнего инструмента"
  },
  "embed_image_1080badc": {
    "message": "Вставить изображение"
  },
  "embed_video_a97a64af": {
    "message": "Вставить видео"
  },
  "embedded_content_aaeb4d3d": {
    "message": "интегрированный контент"
  },
  "empty_set_91a92df4": {
    "message": "Пустое множество"
  },
  "encircled_dot_8f5e51c": {
    "message": "Точка в круге"
  },
  "encircled_minus_72745096": {
    "message": "Минус в круге"
  },
  "encircled_plus_36d8d104": {
    "message": "Плюс в круге"
  },
  "encircled_times_5700096d": {
    "message": "Счет в круге"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Значок техники"
  },
  "english_icon_25bfe845": {
    "message": "Английский значок"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Ввести название медиафайла"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Введите не менее 3 знаков для поиска"
  },
  "enter_replacement_text_17631bbc": {
    "message": "ввести текст для замены"
  },
  "enter_search_text_26cb4459": {
    "message": "ввести текст для поиска"
  },
  "epsilon_54bb8afa": {
    "message": "Эпсилон"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Эпсилон (вариант)"
  },
  "equals_sign_c51bdc58": {
    "message": "Знак равенства"
  },
  "equation_1c5ac93c": {
    "message": "Формула"
  },
  "equation_editor_39fbc3f1": {
    "message": "Редактор уравнений"
  },
  "equilibrium_6ff3040b": {
    "message": "Равенство"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Класс эквивалентности"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Эквивалент (тождественное равенство)"
  },
  "eta_b8828f99": {
    "message": "Эта"
  },
  "exists_2e62bdaa": {
    "message": "Существует"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Выйти из полноэкранного режима"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Разворачивать при предварительном просмотре по умолчанию"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Развернуть для просмотра { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Внешняя ссылка"
  },
  "external_tool_frame_70b32473": {
    "message": "Рамка внешнего инструмента"
  },
  "external_tools_6e77821": {
    "message": "Внешние инструменты"
  },
  "extra_large_b6cdf1ff": {
    "message": "Очень крупный"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Сверхбольшой ({ width } x { height }пикселей)"
  },
  "extra_small_9ae33252": {
    "message": "Очень мелкое изображение"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Значок факультативных дисциплин"
  },
  "f_function_fe422d65": {
    "message": "F (функция)"
  },
  "fail_544e5dde": {
    "message": "СБОЙ"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Не удалось получить содержание файлов"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Не удалось получить содержимое из внешнего инструмента"
  },
  "file_name_8fd421ff": {
    "message": "Имя файла"
  },
  "file_preview_21667a6e": {
    "message": "Предпросмотр файла"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Предпросмотр файла для { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Квота на хранение файлов превышена"
  },
  "file_url_c12b64be": {
    "message": "URL файла"
  },
  "filename_file_icon_602eb5de": {
    "message": "иконка файла { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Предварительный просмотр изображения { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Предварительный просмотр текста { filename }"
  },
  "files_c300e900": {
    "message": "Файлы"
  },
  "files_index_af7c662b": {
    "message": "Индекс файлов"
  },
  "find_8d605019": {
    "message": "Найти"
  },
  "find_and_replace_6e345933": {
    "message": "Поиск и замена"
  },
  "finish_bc343002": {
    "message": "Закончить"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Исправить иерархию заголовков"
  },
  "flat_music_76d5a5c3": {
    "message": "Спокойная (музыка)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Рассмотрение панели инструментов опций элементов"
  },
  "folder_tree_fbab0726": {
    "message": "Структура папки"
  },
  "for_all_b919f972": {
    "message": "Для всех"
  },
  "format_4247a9c5": {
    "message": "Формат"
  },
  "format_as_a_list_142210c3": {
    "message": "Форматировать в виде списка"
  },
  "formatting_5b143aa8": {
    "message": "Форматирование"
  },
  "forward_slash_3f90f35e": {
    "message": "Прямой слэш"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Найдено сохраненное в автоматическом режиме содержимое"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Найдено { count, plural,\n     =0 {# результата(-ов)}\n    one {# результат}\n  other {# результата(-ов)}\n}"
  },
  "fraction_41bac7af": {
    "message": "Фракция"
  },
  "fullscreen_873bf53f": {
    "message": "На весь экран"
  },
  "gamma_1767928": {
    "message": "Гамма"
  },
  "generating_preview_45b53be0": {
    "message": "Создание предварительного просмотра"
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Изображения в формате GIF/PNG с размером более { size } Кб в настоящее время не поддерживаются."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Перейти в строку меню редактора"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Перейти в панель инструментов редактора"
  },
  "grades_a61eba0a": {
    "message": "Оценки"
  },
  "graphics_text_bc9568bc": {
    "message": "Графический текст"
  },
  "greater_than_e98af662": {
    "message": "Больше чем"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Больше чем или равно"
  },
  "greek_65c5b3f7": {
    "message": "Греческий"
  },
  "green_15af4778": {
    "message": "Зеленый"
  },
  "grey_a55dceff": {
    "message": "Серый"
  },
  "group_documents_8bfd6ae6": {
    "message": "Документы группы"
  },
  "group_files_4324f3df": {
    "message": "Файлы группы"
  },
  "group_files_82e5dcdb": {
    "message": "Файлы группы"
  },
  "group_images_98e0ac17": {
    "message": "Изображения группы"
  },
  "group_isomorphism_45b1458c": {
    "message": "Групповой изоморфизм"
  },
  "group_link_63e626b3": {
    "message": "Групповая ссылка"
  },
  "group_links_9493129e": {
    "message": "Групповые ссылки"
  },
  "group_media_2f3d128a": {
    "message": "Медиа группы"
  },
  "group_navigation_99f191a": {
    "message": "Навигация группы"
  },
  "h_bar_bb94deae": {
    "message": "Н вектор"
  },
  "hat_ea321e35": {
    "message": "Крышечка"
  },
  "header_column_f27433cb": {
    "message": "Колонка заголовка"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Строка и колонка заголовка"
  },
  "header_row_f33eb169": {
    "message": "Строка заголовка"
  },
  "heading_2_5b84eed2": {
    "message": "Заголовок 2"
  },
  "heading_3_2c83de44": {
    "message": "Заголовок 3"
  },
  "heading_4_b2e74be7": {
    "message": "Заголовок 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Заголовок { h } применен"
  },
  "heading_h_removed_745f24a6": {
    "message": "Заголовок { h } удален"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Уровни заголовков не должны пропускаться."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Заголовок, начинающийся с { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Заголовки не должны содержать более 120 символов."
  },
  "health_icon_8d292eb5": {
    "message": "Значок здоровья"
  },
  "hearts_suit_e50e04ca": {
    "message": "Червы (масть)"
  },
  "height_69b03e15": {
    "message": "Высота"
  },
  "hexagon_d8468e0d": {
    "message": "Шестиугольник"
  },
  "hide_description_bfb5502e": {
    "message": "Скрыть описание"
  },
  "hide_title_description_caf092ef": {
    "message": "Скрыть описание { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Выделите элемент, чтобы активировать панель инструментов параметров элементов"
  },
  "home_351838cd": {
    "message": "Начальная страница"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Как запросить и отредактировать надпись?"
  },
  "html_code_editor_fd967a44": {
    "message": "Редактор кода html"
  },
  "html_editor_fb2ab713": {
    "message": "Редактор HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Разрешение на использование данного файла получено."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Я являюсь правообладателем"
  },
  "icon_215a1dc6": {
    "message": "Значок"
  },
  "icon_8168b2f8": {
    "message": "значок"
  },
  "icon_color_b86dd6d6": {
    "message": "Цвет значка"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Значки, созданные с помощью средства создания значков"
  },
  "icon_options_7e32746e": {
    "message": "Варианты значка"
  },
  "icon_options_tray_2b407977": {
    "message": "Панель вариантов значков"
  },
  "icon_preview_1782a1d9": {
    "message": "Значок предпросмотра"
  },
  "icon_shape_30b61e7": {
    "message": "Форма значка"
  },
  "icon_size_9353edea": {
    "message": "Размер значка"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Если оставить пустым, текст ссылки будет отображаться как имя ссылки на курс"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Если требуются права на использование, файл не будет опубликован до тех пор, пока он не будет активирован на странице Файлы."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Если вы не выберете права пользования сейчас, этот файл не будет опубликован после отправки."
  },
  "image_8ad06": {
    "message": "Изображение"
  },
  "image_c1c98202": {
    "message": "изображение"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Имена файлов изображений не должны использоваться в качестве альтернативного атрибута с описанием содержимого изображения."
  },
  "image_options_5412d02c": {
    "message": "Опции изображения"
  },
  "image_options_tray_90a46006": {
    "message": "Лоток опций изображения"
  },
  "image_to_crop_3a34487d": {
    "message": "Обрезаемое изображение"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Изображение с именем файла { file }"
  },
  "images_7ce26570": {
    "message": "Изображения"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Изображения должны содержать альтернативный атрибут с описанием содержимого изображения."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Мнимая часть (комплексного числа)"
  },
  "in_element_of_19ca2f33": {
    "message": "В (элемент из)"
  },
  "increase_indent_6af90f7c": {
    "message": "Увеличить отступ"
  },
  "increase_rich_content_area_340b775": {
    "message": "Увеличить область с богатым содержимым"
  },
  "indefinite_integral_6623307e": {
    "message": "Неопределенный интеграл"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } из { max }"
  },
  "indigo_2035fc55": {
    "message": "Индиго"
  },
  "inference_fed5c960": {
    "message": "Логическое рассуждение"
  },
  "infinity_7a10f206": {
    "message": "Бесконечность"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Поле ввода для Альфа"
  },
  "input_field_for_blue_561e020a": {
    "message": "Поле ввода для синего"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Поле ввода для зеленого"
  },
  "input_field_for_red_86a84615": {
    "message": "Поле ввода для красного"
  },
  "insert_593145ef": {
    "message": "Вставить"
  },
  "insert_link_6dc23cae": {
    "message": "Вставить ссылку"
  },
  "insert_math_equation_57c6e767": {
    "message": "Вставить математическое уравнение"
  },
  "integers_336344e1": {
    "message": "Целые числа"
  },
  "intersection_cd4590e4": {
    "message": "Логическое произведение"
  },
  "invalid_description_991e23bb": {
    "message": "Неверное описание"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Неправильная запись."
  },
  "invalid_file_c11ba11": {
    "message": "Неверный файл"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Неверный тип файла"
  },
  "invalid_url_cbde79f": {
    "message": "Неверный URL"
  },
  "iota_11c932a9": {
    "message": "Йота"
  },
  "issue_num_total_f94536cf": {
    "message": "Проблема { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Курсив применен"
  },
  "italic_removed_17cbab6f": {
    "message": "Курсив удален"
  },
  "kappa_2f14c816": {
    "message": "Каппа"
  },
  "kappa_variant_eb64574b": {
    "message": "Каппа (вариант)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Клавиши быстрого доступа"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Клавиатуры используются для перехода по ссылкам с помощью клавиши Tab. Две соседние ссылки, ведущие в одно и то же место, могут запутывать пользователей клавиатур."
  },
  "lambda_4f602498": {
    "message": "Лямбда"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Значок языковых дисциплин"
  },
  "languages_icon_9d20539": {
    "message": "Значок языков"
  },
  "large_9c5e80e7": {
    "message": "Большой"
  },
  "large_text_e7ba08cd": {
    "message": "Большой текст"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Большой ({ width } x { height }пикселей)"
  },
  "learn_ad3b3505": {
    "message": "Обучение"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Узнать больше о соседних ссылках"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Узнать больше о цветовом контрасте"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Узнать больше об организации заголовков страниц"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Узнайте больше о правильной структуре заголовков страниц"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Узнать больше о заголовках таблиц"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Узнать больше об использовании замещающего текста для изображений"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Узнать больше об использовании заголовков с таблицами"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Узнать больше об использовании имен файлов в качестве замещающего текста"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Узнать больше об использовании списков"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Узнать больше об использовании базовых атрибутов с таблицами"
  },
  "leave_as_is_4facfe55": {
    "message": "Оставить как есть"
  },
  "left_3ea9d375": {
    "message": "Слева"
  },
  "left_align_43d95491": {
    "message": "Совмещение по левому краю"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Левая угловая скобка"
  },
  "left_arrow_4fde1a64": {
    "message": "Стрелка влево"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Стрелка влево с крючком"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Потолок числа, левая скобка"
  },
  "left_curly_brace_1726fb4": {
    "message": "Левая фигурная скобка"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Стрелка-гарпун влево с крюком снизу"
  },
  "left_floor_29ac2274": {
    "message": "Пол числа, левая скобка"
  },
  "left_to_right_e9b4fd06": {
    "message": "Слева направо"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Стрелка-гарпун влево с крюком сверху"
  },
  "leftward_arrow_1e4765de": {
    "message": "Стрелка влево"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Треугольник вершиной влево"
  },
  "less_than_a26c0641": {
    "message": "Меньше чем"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Меньше чем или равно"
  },
  "library_icon_ae1e54cf": {
    "message": "Значок библиотеки"
  },
  "light_blue_5374f600": {
    "message": "Светло-синий"
  },
  "link_7262adec": {
    "message": "Ссылка"
  },
  "link_options_a16b758b": {
    "message": "Параметры ссылки"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "тип ссылки: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Ссылка с текстом, начинающимся с { start }"
  },
  "links_14b70841": {
    "message": "Ссылки"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Ссылки на внешний сайт."
  },
  "lists_cd1336fc": {
    "message": "Списки"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Списки должны быть отформатированы в виде списков."
  },
  "load_more_35d33c7": {
    "message": "Загрузить еще"
  },
  "loading_25990131": {
    "message": "Выполняется загрузка..."
  },
  "loading_bde52856": {
    "message": "Загрузка"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Сбой загрузки закрытых надписей/субтитров."
  },
  "loading_external_tool_d839042c": {
    "message": "Загрузка внешнего инструмента"
  },
  "loading_failed_b3524381": {
    "message": "Загрузка завершилась безрезультатно..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Сбой загрузки."
  },
  "loading_folders_d8b5869e": {
    "message": "Загрузка папок"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Скачивание заполнителя для { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Выполняется загрузка, подождите..."
  },
  "loading_preview_9f077aa1": {
    "message": "Загрузка предпросмотра"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Блокировка скорости на 1x"
  },
  "locked_762f138b": {
    "message": "Заблокировано"
  },
  "logical_equivalence_76fca396": {
    "message": "Логическая эквивалентность"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Логическая эквивалентность (короткая)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Логическая эквивалентность (короткая и жирная)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Логическая эквивалентность (жирная)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Нижние горизонтальные точки"
  },
  "magenta_4a65993c": {
    "message": "Пурпурный"
  },
  "maps_to_e5ef7382": {
    "message": "Совмещает с"
  },
  "math_icon_ad4e9d03": {
    "message": "Значок математики"
  },
  "media_af190855": {
    "message": "Мультимедиа"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Выполняется обработка файла мультимедиа. Попробуйте еще раз позже."
  },
  "media_options_saved_560c4ec8": {
    "message": "Параметры мультимедиа сохранены."
  },
  "media_title_2112243b": {
    "message": "Название мультимедиа"
  },
  "medium_5a8e9ead": {
    "message": "Средний"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Средний ({ width } x { height }пикселей)"
  },
  "merge_links_2478df96": {
    "message": "Объединить ссылки"
  },
  "mic_a7f3d311": {
    "message": "Микрофон"
  },
  "microphone_disabled_15c83130": {
    "message": "Микрофон отключен"
  },
  "middle_27dc1d5": {
    "message": "Середина"
  },
  "minimize_file_preview_da911944": {
    "message": "Уменьшить просмотр файла"
  },
  "minimize_video_20aa554b": {
    "message": "Уменьшить видео"
  },
  "minus_fd961e2e": {
    "message": "Минус"
  },
  "minus_plus_3461f637": {
    "message": "Минус/Плюс"
  },
  "misc_3b692ea7": {
    "message": "Различное"
  },
  "miscellaneous_e9818229": {
    "message": "Разное"
  },
  "module_90d9fd32": {
    "message": "Модуль"
  },
  "modules_c4325335": {
    "message": "Модули"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Перемещение изображения для обрезки { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Мю"
  },
  "multi_color_image_63d7372f": {
    "message": "Многоцветное изображение"
  },
  "multiplication_sign_15f95c22": {
    "message": "Знак умножения"
  },
  "music_icon_4db5c972": {
    "message": "Значок музыки"
  },
  "my_files_2f621040": {
    "message": "Мои файлы"
  },
  "n_th_root_9991a6e4": {
    "message": "Корень N-й степени"
  },
  "nabla_1e216d25": {
    "message": "Набла"
  },
  "name_1aed4a1b": {
    "message": "Имя"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Натуральная (музыка)"
  },
  "natural_numbers_3da07060": {
    "message": "Натуральные числа"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Навигация в меню или панели инструментов"
  },
  "navigation_ee9af92d": {
    "message": "Навигация"
  },
  "nested_greater_than_d852e60d": {
    "message": "Вложенный знак больше чем"
  },
  "nested_less_than_27d17e58": {
    "message": "Вложенный знак меньше чем"
  },
  "new_quiz_34aacba6": {
    "message": "Новое тестирование"
  },
  "next_40e12421": {
    "message": "Далее"
  },
  "next_findtext_9d69f0fe": {
    "message": "Далее { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Проблем, связанных с доступностью, не обнаружено."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Объявления пока что не созданы."
  },
  "no_announcements_found_20185afc": {
    "message": "Объявления не найдены."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Задания пока что не созданы."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Задания не найдены."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Нет изменений для сохранения."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Обсуждения пока что не созданы."
  },
  "no_discussions_found_9284063b": {
    "message": "Обсуждения не найдены."
  },
  "no_e16d9132": {
    "message": "Нет"
  },
  "no_file_chosen_9a880793": {
    "message": "Не выбран ни один файл"
  },
  "no_headers_9bc7dc7f": {
    "message": "Заголовки отсутствуют"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Модули пока что не созданы."
  },
  "no_modules_found_2df43a40": {
    "message": "Модули не найдены."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Пока не создано ни одной страницы."
  },
  "no_pages_found_6799350": {
    "message": "Страницы не найдены."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Предварительный просмотр для этого файла невозможен."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Тесты пока что не созданы."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Тесты не найдены."
  },
  "no_results_940393cf": {
    "message": "Нет результатов."
  },
  "no_results_found_58717065": {
    "message": "Результаты не найдены"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Не найдены результаты для { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Видео отсутствует"
  },
  "none_3b5e34d2": {
    "message": "Нет"
  },
  "none_selected_b93d56d2": {
    "message": "Нет выбранных элементов"
  },
  "normal_text_7b03da48": {
    "message": "Обычный текст"
  },
  "not_equal_6e2980e6": {
    "message": "Не равно"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Не в (не элемент из)"
  },
  "not_negation_1418ebb8": {
    "message": "Нет (отрицание)"
  },
  "not_subset_dc2b5e84": {
    "message": "Не подмножество значений"
  },
  "not_subset_strict_23d282bf": {
    "message": "Не подмножество значений (жесткое)"
  },
  "not_superset_5556b913": {
    "message": "Не супермножество"
  },
  "not_superset_strict_24e06f36": {
    "message": "Не супермножество (жесткое)"
  },
  "nu_1c0f6848": {
    "message": "Ню"
  },
  "octagon_e48be9f": {
    "message": "Восьмиугольник"
  },
  "olive_6a3e4d6b": {
    "message": "Оливковый"
  },
  "omega_8f2c3463": {
    "message": "Омега"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Один из следующих стилей должен быть добавлен для сохранения значка: Цвет Значка, Размер Контура, Текст Значка или Изображение"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Не удалось вставить один или более файлов. Попробуйте загрузить или перетащить файлы."
  },
  "open_circle_e9bd069": {
    "message": "Открытый круг"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Открыть этот диалог комбинаций клавиш"
  },
  "open_title_application_fd624fc5": {
    "message": "Открыть приложение { title }"
  },
  "operators_a2ef9a93": {
    "message": "Операторы"
  },
  "options_3ab0ea65": {
    "message": "Опции"
  },
  "or_9b70ccaa": {
    "message": "Или"
  },
  "orange_81386a62": {
    "message": "Оранжевый"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Упорядоченные и неупорядоченные списки"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Другие ярлыки редактора можно найти на"
  },
  "outline_color_3ef2cea7": {
    "message": "Цвет контура"
  },
  "outline_size_a6059a21": {
    "message": "Размер контура"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } не является действительным протоколом."
  },
  "page_50c4823d": {
    "message": "Страница"
  },
  "pages_e5414c2c": {
    "message": "Страницы"
  },
  "paragraph_5e5ad8eb": {
    "message": "Параграф"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Параграф применен"
  },
  "paragraph_removed_d09320e": {
    "message": "Параграф удален"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Параграф, начинающийся с { start }"
  },
  "parallel_d55d6e38": {
    "message": "Параллельно"
  },
  "partial_derivative_4a9159df": {
    "message": "Элементарная (производная)"
  },
  "pass_1c19a2b3": {
    "message": "ПРОЙДЕНО"
  },
  "paste_5963d1c1": {
    "message": "Вставить"
  },
  "pause_12af3bb4": {
    "message": "Пауза"
  },
  "pentagon_17d82ea3": {
    "message": "Пятиугольник"
  },
  "people_b4ebb13c": {
    "message": "Люди"
  },
  "percentage_34ab7c2c": {
    "message": "Процент"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Процентное значение должно быть указано в виде числа"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Процентное значение должно быть не ниже { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Значок исполнительских видов искусства"
  },
  "perpendicular_7c48ede4": {
    "message": "Перпендикулярно"
  },
  "phi_4ac33b6d": {
    "message": "Фи"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Фи (вариант)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Значок физкультуры"
  },
  "pi_dc4f0bd8": {
    "message": "Пи"
  },
  "pi_variant_10f5f520": {
    "message": "Пи (вариант)"
  },
  "pick_a_color_557abfb0": {
    "message": "Выбрать цвет"
  },
  "pink_68ad45cb": {
    "message": "Розовый"
  },
  "pixels_52ece7d1": {
    "message": "Пиксели"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Плотность пикселей должна быть минимум { width } x { height }"
  },
  "play_1a47eaa7": {
    "message": "Воспроизвести"
  },
  "play_media_comment_35257210": {
    "message": "Воспроизведение мультимедийного комментария."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Воспроизвести мультимедийный комментарии { name } из { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Формат плеера"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Разрешите Canvas доступ к вашему микрофону и веб-камере."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Выберите файл"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Введите имя файла"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Введите действительный URL-адрес видео с поддерживаемой платформы."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Выберите файл поддерживаемого типа"
  },
  "plus_d43cd4ec": {
    "message": "Плюс"
  },
  "plus_minus_f8be2e83": {
    "message": "Плюс/Минус"
  },
  "posted_when_a578f5ab": {
    "message": "Размещено: { when }"
  },
  "power_set_4f26f316": {
    "message": "Множество всех подмножеств"
  },
  "precedes_196b9aef": {
    "message": "Предваряет"
  },
  "precedes_equal_20701e84": {
    "message": "Предваряет сравнение"
  },
  "preformatted_d0670862": {
    "message": "Предварительно форматированный"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Назад"
  },
  "preview_53003fd2": {
    "message": "Предпросмотр"
  },
  "preview_a3f8f854": {
    "message": "ПРЕДПРОСМОТР"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Предварительный просмотр в наложении"
  },
  "preview_inline_9787330": {
    "message": "Предварительный просмотр в сетевом режиме"
  },
  "previous_bd2ac015": {
    "message": "Предыдущий"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Предыдущий { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Ранее выбранные цвета"
  },
  "prime_917ea60e": {
    "message": "Знак штриха"
  },
  "prime_numbers_13464f61": {
    "message": "Простые числа"
  },
  "product_39cf144f": {
    "message": "Продукт"
  },
  "proportional_f02800cc": {
    "message": "Пропорциональный"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Протокол должен быть ftp, http, https, mailto, skype, tel или может не указываться"
  },
  "psi_e3f5f0f7": {
    "message": "Пси"
  },
  "published_c944a23d": {
    "message": "опубликовано"
  },
  "published_when_302d8e23": {
    "message": "Опубликовано: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Цвет тыквы"
  },
  "purple_7678a9fc": {
    "message": "Пурпурный"
  },
  "quaternions_877024e0": {
    "message": "Кватернионы"
  },
  "quiz_e0dcce8f": {
    "message": "Тест"
  },
  "quizzes_7e598f57": {
    "message": "Тесты"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Рациональные числа"
  },
  "real_numbers_7c99df94": {
    "message": "Вещественные числа"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Реальная часть (комплексного числа)"
  },
  "record_7c9448b": {
    "message": "Запись"
  },
  "record_upload_media_5fdce166": {
    "message": "Записать / загрузить мультимедиа"
  },
  "recording_98da6bda": {
    "message": "Запись"
  },
  "red_8258edf3": {
    "message": "Красный"
  },
  "relationships_6602af70": {
    "message": "Отношения"
  },
  "religion_icon_246e0be1": {
    "message": "Значок религии"
  },
  "remove_f47dc62a": {
    "message": "Удалить"
  },
  "remove_filename_3ea029f6": {
    "message": "Удалить { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Удалить стиль заголовка"
  },
  "remove_link_d1f2f4d0": {
    "message": "Удалить ссылку"
  },
  "replace_all_d3d68b3": {
    "message": "Заменить все"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Заменить все { findText } на { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Заменить"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Заменить { findText } на { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Заменить на"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "{ alertFindText } заменено на { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Заменить все { alertFindText } на { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Восстановить"
  },
  "resize_ec83d538": {
    "message": "Изменить размер"
  },
  "restore_auto_save_deccd84b": {
    "message": "Восстановить автосохранение?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Результат { index } из { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Перевернутый турникет (не возвращает значение)"
  },
  "rho_a0244a36": {
    "message": "Ро"
  },
  "rho_variant_415245cd": {
    "message": "Ро (вариант)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Редактор форматированного текста"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Область форматированного текста. Нажмите { OSKey }+F8 для отображения клавиш быстрого доступа редактора форматированного содержимого."
  },
  "right_71ffdc4d": {
    "message": "Справа"
  },
  "right_align_39e7a32a": {
    "message": "Совмещение по правому краю"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Правая угловая скобка"
  },
  "right_arrow_35e0eddf": {
    "message": "Стрелка вправо"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Стрелка вправо с крючком"
  },
  "right_ceiling_839dc744": {
    "message": "Потолок числа, правая скобка"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Правая фигурная скобка"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Стрелка-гарпун вправо с крюком снизу"
  },
  "right_floor_5392d5cf": {
    "message": "Пол числа, правая скобка"
  },
  "right_to_left_9cfb092a": {
    "message": "Справа налево"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Стрелка-гарпун вправо с крюком сверху"
  },
  "rightward_arrow_32932107": {
    "message": "Стрелка вправо"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Треугольник вершиной вправо"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Поворот изображения на -90 градусов"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Поворот изображения на 90 градусов"
  },
  "rotation_9699c538": {
    "message": "Вращение"
  },
  "row_fc0944a7": {
    "message": "Строка"
  },
  "row_group_979f5528": {
    "message": "Группа строк"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "К сожалению, возможность доступа к редактору Pretty HTML с клавиатуры отсутствует. Обратитесь к редактору Raw HTML здесь."
  },
  "save_11a80ec3": {
    "message": "Сохранить"
  },
  "save_copy_ca63944e": {
    "message": "Сохранить копию"
  },
  "save_media_cb9e786e": {
    "message": "Сохранить ресурс"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Сохраненные значки, созданные с помощью Средства создания значков"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Экранные дикторы не могут определить, что отображено на изображении, без альтернативного текста, и при этом имена файлов зачастую представляют собой бессмысленные наборы цифр и букв, которые не несут в себе описания контекста или значения."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Экранные дикторы не могут определить, что отображено на изображении, без альтернативного текста, содержащего описание контекста и значения изображения. Альтернативный текст должен быть простым и сжатым."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Экранные дикторы не могут определить, что отображено на изображении, без альтернативного текста, содержащего описание контекста и значения изображения."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Экранные дикторы не могут интерпретировать таблицы без надлежащей структуры. Заголовки таблиц содержат направление и объем содержания."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Экранные дикторы не могут интерпретировать таблицы без надлежащей структуры. Надписи в таблицах содержат описание контекста и общее представление о таблице."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Экранные дикторы не могут интерпретировать таблицы без надлежащей структуры. Заголовки таблиц содержат направление и общее описание содержания."
  },
  "script_l_42a7b254": {
    "message": "Набор символов L"
  },
  "search_280d00bd": {
    "message": "Поиск"
  },
  "select_audio_source_21043cd5": {
    "message": "Выбрать источник аудио"
  },
  "select_crop_shape_d441feeb": {
    "message": "Выберите обрезку формы"
  },
  "select_language_7c93a900": {
    "message": "Выбрать язык"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Выбрать источник видео"
  },
  "selected_274ce24f": {
    "message": "Выбрано"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Выбранное { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Выбор"
  },
  "set_header_scope_8c548f40": {
    "message": "Задать объем заголовка"
  },
  "set_minus_b46e9b88": {
    "message": "Установка минуса"
  },
  "set_table_header_cfab13a0": {
    "message": "Задать заголовок таблицы"
  },
  "sharp_music_ab956814": {
    "message": "Резкая (музыка)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+стрелки"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Нажать Shift-O, чтобы открыть редактор Pretty HTML."
  },
  "shortcut_911d6255": {
    "message": "Ярлык"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Показать варианты изображения"
  },
  "show_link_options_545338fd": {
    "message": "Показать параметры ссылки"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Показать непрерывную стенограмму"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Показать непрерывную стенограмму"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Зрячие пользователи быстро просматривают веб-страницы в поисках крупных или полужирных заголовков. Пользователи экранных дикторов полагаются на заголовки для контекстуального понимания. Заголовки должны иметь надлежащую структуру."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Зрячие пользователи быстро просматривают веб-страницы в поисках крупных или полужирных заголовков. Пользователи экранных дикторов полагаются на заголовки для контекстуального понимания. Заголовки должны быть сжатыми в рамках надлежащей структуры."
  },
  "sigma_5c35e553": {
    "message": "Сигма"
  },
  "sigma_variant_8155625": {
    "message": "Сигма (вариант)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Одноцветное изображение"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Одноцветное изображение"
  },
  "size_b30e1077": {
    "message": "Размер"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Размер файла субтитров больше допустимого максимального размера в { max } Кб."
  },
  "small_b070434a": {
    "message": "Маленький"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Малый ({ width } x { height }пикселей)"
  },
  "solid_circle_9f061dfc": {
    "message": "Темная точка"
  },
  "something_went_wrong_89195131": {
    "message": "Возникла проблема."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Сбой при попытке доступа к вашей веб-камере."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Что-то пошло не так, и я не знаю, что вам показать."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Что-то пошло не так. Проверьте свое соединение, перезагрузите страницу и попробуйте еще раз."
  },
  "something_went_wrong_d238c551": {
    "message": "Что-то пошло не так"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Что-то пошло не так при предоставлении доступа к вашему экрану."
  },
  "sort_by_e75f9e3e": {
    "message": "Сортировать по"
  },
  "spades_suit_b37020c2": {
    "message": "Пики (масть)"
  },
  "square_511eb3b3": {
    "message": "Квадрат"
  },
  "square_cap_9ec88646": {
    "message": "Пересечение в квадрате"
  },
  "square_cup_b0665113": {
    "message": "Объединение в квадрате"
  },
  "square_root_e8bcbc60": {
    "message": "Квадратный корень"
  },
  "square_root_symbol_d0898a53": {
    "message": "Символ квадратного корня"
  },
  "square_subset_17be67cb": {
    "message": "Подмножество квадрата"
  },
  "square_subset_strict_7044e84f": {
    "message": "Подмножество квадрата (жесткое)"
  },
  "square_superset_3be8dae1": {
    "message": "Супермножество квадрата"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Супермножество квадрата (жесткое)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "заключить неупорядоченный список в квадрат"
  },
  "star_8d156e09": {
    "message": "Звезда"
  },
  "start_over_f7552aa9": {
    "message": "Начать заново"
  },
  "start_recording_9a65141a": {
    "message": "Запустить запись"
  },
  "steel_blue_14296f08": {
    "message": "Синий со стальным отливом"
  },
  "studio_media_options_ee504361": {
    "message": "Варианты Studio Media"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Лоток для вариантов Studio Media"
  },
  "styles_2aa721ef": {
    "message": "Стили"
  },
  "submit_a3cc6859": {
    "message": "Отправить"
  },
  "submitting_b90fac62": {
    "message": "Выполняется отправка..."
  },
  "subscript_59744f96": {
    "message": "Надпись снизу"
  },
  "subset_19c1a92f": {
    "message": "Подмножество"
  },
  "subset_strict_8d8948d6": {
    "message": "Подмножество (жесткое)"
  },
  "succeeds_9cc31be9": {
    "message": "Получается"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Получается равно"
  },
  "sum_b0842d31": {
    "message": "Сумма"
  },
  "superscript_8cb349a2": {
    "message": "Надпись сверху"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Надпись сверху и надпись снизу"
  },
  "superset_c4db8a7a": {
    "message": "Супермножество"
  },
  "superset_strict_c77dd6d2": {
    "message": "Супермножество (жесткое)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Поддерживаемые типы файлов: SRT или WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Перейти в редактор Pretty HTML"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Перейти в редактор Raw HTML"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Перейти в редактор html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Перейти в редактор форматированного текста"
  },
  "syllabus_f191f65b": {
    "message": "Содержание курса"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Системный звук разрешен"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Системный звук отключен"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Стрелки"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Заголовок таблицы, начинающийся с { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Таблица, начинающаяся с { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Заголовки таблиц должны конкретизировать объем."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Таблицы должны содержать надпись с описанием содержимого таблицы."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Таблицы должны содержать как минимум один заголовок."
  },
  "tau_880974b7": {
    "message": "Тау"
  },
  "teal_f729a294": {
    "message": "Бирюзовый"
  },
  "text_7f4593da": {
    "message": "Текст"
  },
  "text_background_color_16e61c3f": {
    "message": "Цвет фона текста"
  },
  "text_color_acf75eb6": {
    "message": "Цвет текста"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Текст трудно поддается чтению без достаточной контрастности между текстом и фоном, особенно для тех, кто плохо видит."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Текст крупнее 18pt (или полужирный 14pt) должен отображаться с минимальным коэффициентом контрастности 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Текст (опционально)"
  },
  "text_position_8df8c162": {
    "message": "Положение текста"
  },
  "text_size_887c2f6": {
    "message": "Размер текста"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Текст мельче 18pt (или полужирный 14pt) должен отображаться с минимальным коэффициентом контрастности 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Предварительный просмотр документа в данный момент обрабатывается. Попробуйте еще раз позже."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Первый заголовок на странице должен быть H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Высота области с богатым содержимым уменьшена."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Высота области с богатым содержимым увеличена."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Материал находится в общедоступном домене"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Материал распространяется по лицензии Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Материал подпадает под действие правовой оговорки - например, касательно добросовестного использования, права цитирования или иной правовой оговорки согласно действующему законодательству об авторских правах"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Возможность доступа к редактору Pretty HTML с клавиатуры отсутствует. Нажать Shift-O, чтобы открыть редактор Raw HTML."
  },
  "therefore_d860e024": {
    "message": "Следовательно"
  },
  "theta_ce2d2350": {
    "message": "Тета"
  },
  "theta_variant_fff6da6f": {
    "message": "Тета (вариант)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Направленная вниз жирная стрелка"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Жирная стрелка влево"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Направленная влево жирная стрелка"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Толстая стрелка вправо"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Направленная вправо жирная стрелка"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Направленная вверх жирная стрелка"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Этот документ нельзя отобразить внутри Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Данное уравнение не может быть отображено в основном виде."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Это изображение в настоящее время недоступно"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "В этом видео может содержаться реклама YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Хотя у вашего видео правильный заголовок в браузере, нам не удалось обновить его в базе данных."
  },
  "thumbnail_e0de666f": {
    "message": "Пиктограмма"
  },
  "timebar_a4d18443": {
    "message": "Шкала времени"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Заголовок не может быть пустым"
  },
  "title_ee03d132": {
    "message": "Заголовок"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Для размещения: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Задачи: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Переключиться на группу { summary }"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Переключение подсказки"
  },
  "tools_2fcf772e": {
    "message": "Инструменты"
  },
  "top_66e0adb6": {
    "message": "Верх"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Панель стенограммы доступна при ширине экрана более 720 пикселей."
  },
  "tray_839df38a": {
    "message": "Лоток"
  },
  "triangle_6072304e": {
    "message": "Треугольник"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Турникет (возвращает значение)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "Наберите Control F9 для доступа к опциям изображения. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "Наберите Control F9 для доступа к опциям ссылки. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "Наберите Control F9 для доступа к опциям таблицы. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Невозможно определить URL выбора ресурсов"
  },
  "underline_applied_ae01ec97": {
    "message": "Подчеркивание применено"
  },
  "underline_removed_3693e17c": {
    "message": "Подчеркивание удалено"
  },
  "union_e6b57a53": {
    "message": "Множество"
  },
  "unpublished_dfd8801": {
    "message": "не опубликовано"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Несохраненные изменения будут потеряны."
  },
  "untitled_16aa4f2b": {
    "message": "Без названия"
  },
  "untitled_efdc2d7d": {
    "message": "без названия"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Направленная вверх и влево диагональная стрелка"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Направленная вверх и вправо диагональная стрелка"
  },
  "up_c553575d": {
    "message": "Вверх"
  },
  "updated_link_a827e441": {
    "message": "Обновленная ссылка"
  },
  "upload_document_253f0478": {
    "message": "Загрузить документ"
  },
  "upload_file_fd2361b8": {
    "message": "Загрузить файл"
  },
  "upload_image_6120b609": {
    "message": "Загрузить изображение"
  },
  "upload_media_ce31135a": {
    "message": "Загрузить медиа"
  },
  "upload_record_media_e4207d72": {
    "message": "Загрузить/записать медиа"
  },
  "uploading_19e8a4e7": {
    "message": "Загрузка"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "упорядоченный алфавитный список в верхнем регистре"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Дельта в верхнем регистре"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Гамма в верхнем регистре"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Лямбда в верхнем регистре"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Омега в верхнем регистре"
  },
  "uppercase_phi_caa36724": {
    "message": "Фи в верхнем регистре"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Пи в верхнем регистре"
  },
  "uppercase_psi_6395acbe": {
    "message": "Пси в верхнем регистре"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "нумерованный упорядоченный список в верхнем регистре, шрифт Roman"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Сигма в верхнем регистре"
  },
  "uppercase_theta_49afc891": {
    "message": "Тета в верхнем регистре"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Ипсилон в верхнем регистре"
  },
  "uppercase_xi_341e8556": {
    "message": "Кси в верхнем регистре"
  },
  "upsilon_33651634": {
    "message": "Ипсилон"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Направления вверх и вниз стрелка"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Направления вверх и вниз стрелка (жирная)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Направленная вверх стрелка"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Треугольник вершиной вверх"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Право на использование:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Права на использование (обязательно)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Используйте клавиши со стрелками для навигации по параметрам."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Используйте клавиши со стрелками для выбора формы."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Используйте клавиши со стрелками для выбора размера."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Используйте клавиши со стрелками для выбора положения текста."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Используйте клавиши со стрелками для выбора размера текста."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Используйте клавиши со стрелками для выбора размера контура."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Используется скринридерами для описания контента { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Используется скринридерами для описания контента изображения"
  },
  "user_documents_c206e61f": {
    "message": "Документы пользователя"
  },
  "user_files_78e21703": {
    "message": "Файлы пользователя"
  },
  "user_images_b6490852": {
    "message": "Изображения пользователя"
  },
  "user_media_14fbf656": {
    "message": "Пользовательское мультимедиа"
  },
  "vector_notation_cf6086ab": {
    "message": "Вектор (запись)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Вертикальная черта (форма записи множества)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Вертикальные точки"
  },
  "video_options_24ef6e5d": {
    "message": "Параметры видео"
  },
  "video_options_tray_3b9809a5": {
    "message": "Лоток параметров видео"
  },
  "video_player_b371005": {
    "message": "Видео-плеер"
  },
  "video_player_for_9e7d373b": {
    "message": "Видеоплеер для "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Видеоплеер для { title }"
  },
  "video_url_889d3263": {
    "message": "URL видео"
  },
  "view_all_e13bf0a6": {
    "message": "Просмотреть все"
  },
  "view_ba339f93": {
    "message": "Просмотр"
  },
  "view_description_30446afc": {
    "message": "Просмотреть описание"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Показать клавиши быстрого доступа"
  },
  "view_title_description_67940918": {
    "message": "Просмотреть описание { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Просмотреть подсчет количества слов и символов"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Ограничения просмотра"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Не удалось обнаружить работающий микрофон, подключенный к вашему устройству."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Не удалось обнаружить работающую веб-камеру, подключенную к вашему устройству."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Не удалось обнаружить работающие микрофон или веб-камеру, подключенные к вашему устройству."
  },
  "webcam_disabled_30c66986": {
    "message": "Веб-камера отключена"
  },
  "webcam_fe91b20f": {
    "message": "Веб-камера"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Веб-страницы должны иметь только один H1, который автоматически используется в качестве заголовка страницы. Первый заголовок в вашем содержимом должен быть H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Когда используется разметка, которая визуально форматирует элементы в виде списка, но не указывает на отношение списка, пользователи могут испытывать трудности при просмотре информации."
  },
  "white_87fa64fd": {
    "message": "Белый"
  },
  "why_523b3d8c": {
    "message": "Почему"
  },
  "width_492fec76": {
    "message": "Ширина"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Ширина и высоты должны выражаться числами"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }пикселов"
  },
  "wiki_home_9cd54d0": {
    "message": "Домашняя страница вики"
  },
  "word_count_c77fe3a6": {
    "message": "Количество слов"
  },
  "words_b448b7d5": {
    "message": "Cлова"
  },
  "wreath_product_200b38ef": {
    "message": "Веночное произведение"
  },
  "xi_149681d0": {
    "message": "Кси"
  },
  "yes_dde87d5": {
    "message": "Да"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Вы находитесь в цветовой палитре. Для перемещения по палитре вверх, влево, вниз или вправо используются кнопки «W», «A», «S» и «D» соответственно."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Вы находитесь на ползунке настройки цвета. Для перемещения ползунка влево или вправо используются кнопки «A» и «D» соответственно."
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Вы находитесь на ползунке Альфа. Для перемещения ползунка влево или вправо используются кнопки «A» и «D» соответственно."
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "У вас есть несохраненные изменения в лотке Средства создания значков. Вы хотите продолжить без сохранения этих изменений?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Возможно, вам потребуется настроить дополнительные заголовки, чтобы сохранить иерархию страниц."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Вы не можете отправить пустой файл."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Ваше изображение было сжато для Средства создания значков. Изображения с размером менее { size } Кб сжиматься не будут."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Ваш микрофон заблокирован в настройках браузера."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Ваши микрофон и веб-камера заблокированы в настройках браузера."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Ваша веб-камера заблокирована в настройках браузера."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Ваша веб-камера может уже использоваться."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL для вставки в YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Зета"
  },
  "zoom_f3e54d69": {
    "message": "Изменить масштаб"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Увеличение изображения"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Уменьшить изображение"
  }
};
formatMessage.addLocale({
  ru: locale
});